import { useCallback } from 'react';
import { fetchJsonResource } from './fetchJsonResource';
import useResource from './useResource';
import createListingCache from './listingCache';

const CATEGORIES_ROUTE = 'evp_ticket_frontend.api.categories';
const INITIAL_DATA = Object.freeze([]);

const categoriesCache = createListingCache('categories');

function normalizeCategories(data) {
    if (!Array.isArray(data)) {
        return [];
    }
    return data
        .filter(entry => entry && typeof entry.id === 'number' && typeof entry.name === 'string')
        .map(({ id, name }) => ({ id, name }));
}

function useCategories() {
    const fetchFn = useCallback(
        (_key, { signal }) => fetchJsonResource(CATEGORIES_ROUTE, {}, { signal }).then(normalizeCategories),
        [],
    );

    const {
        data, status, errorKind, retry,
    } = useResource(fetchFn, CATEGORIES_ROUTE, { initialData: INITIAL_DATA, cache: categoriesCache });

    return {
        categories: data ?? INITIAL_DATA,
        loading: status === 'idle' || status === 'loading',
        error: status === 'error' ? errorKind : null,
        retry,
    };
}

export default useCategories;
